<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>
<empty-layout *ngIf="layout === 'empty'"></empty-layout>
